"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpButton = void 0;
const preact_1 = require("preact");
const typestyle_1 = require("typestyle");
const Controls_style_1 = require("../../Controls.style");
const style_1 = require("./style");
class HelpButton extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.state = { open: false };
        this.toggle = (event) => {
            event.stopPropagation();
            this.setState({ open: !this.state.open });
        };
    }
    render() {
        return (0, preact_1.h)("div", { class: style_1.HelpButtonStyle.container },
            (0, preact_1.h)("div", { class: (0, typestyle_1.classes)(Controls_style_1.ControlsStyle.button, style_1.HelpButtonStyle.button), title: "Keyboard controls", onClick: this.toggle }, "?"),
            this.state.open && (0, preact_1.h)("div", { class: style_1.HelpButtonStyle.panel, onClick: (event) => event.stopPropagation() },
                (0, preact_1.h)("div", { class: style_1.HelpButtonStyle.heading },
                    "Controls ",
                    (0, preact_1.h)("span", null, "click ? to close")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "Space"),
                    " / ",
                    (0, preact_1.h)("kbd", null, "K"),
                    (0, preact_1.h)("b", null, "Play / pause")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "J"),
                    " ",
                    (0, preact_1.h)("kbd", null, "L"),
                    " / ",
                    (0, preact_1.h)("kbd", null, "\u2190"),
                    " ",
                    (0, preact_1.h)("kbd", null, "\u2192"),
                    (0, preact_1.h)("b", null, "Seek 5 seconds")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "Q"),
                    " ",
                    (0, preact_1.h)("kbd", null, "E"),
                    (0, preact_1.h)("b", null, "Previous / next POV")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "["),
                    " ",
                    (0, preact_1.h)("kbd", null, "]"),
                    (0, preact_1.h)("b", null, "Playback speed")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "C"),
                    (0, preact_1.h)("b", null, "Replay / free camera")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "W A S D"),
                    (0, preact_1.h)("b", null, "Free-camera movement")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "Shift"),
                    " / ",
                    (0, preact_1.h)("kbd", null, "Ctrl"),
                    (0, preact_1.h)("b", null, "Free camera up / down")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "Left click"),
                    (0, preact_1.h)("b", null, "Capture mouse in free camera")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "Esc"),
                    " / ",
                    (0, preact_1.h)("kbd", null, "Right click"),
                    (0, preact_1.h)("b", null, "Release mouse / close map")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "M"),
                    (0, preact_1.h)("b", null, "Toggle minimap")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "O"),
                    (0, preact_1.h)("b", null, "Open replay menu")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("kbd", null, "V"),
                    (0, preact_1.h)("b", null, "Mute"),
                    " ",
                    (0, preact_1.h)("kbd", null, "F"),
                    (0, preact_1.h)("b", null, "Fullscreen"))));
    }
}
exports.HelpButton = HelpButton;
